var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-org" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { staticClass: "search-form" },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: { inline: true, model: _vm.searchForm },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "人员名称" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入人员名称", clearable: "" },
                        model: {
                          value: _vm.searchForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "name", $$v)
                          },
                          expression: "searchForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入手机号", clearable: "" },
                        model: {
                          value: _vm.searchForm.chMobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "chMobile", $$v)
                          },
                          expression: "searchForm.chMobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("查询")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.orgList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "chPersonCode",
                  label: "人员编码",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "chPersonName", label: "人员名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "chMobile",
                  label: "手机号",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "chProductTypeDept", label: "出品部门" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "chRoleName", label: "角色" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "roleIds",
                  label: "员工角色",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.roleIds, function (item) {
                        return _c(
                          "el-tag",
                          { key: item, attrs: { size: "small" } },
                          [_vm._v(_vm._s(_vm.getRoleName(item)))]
                        )
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "chStoreCodePos", label: "门店编码POS" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "chStoreNamePos",
                  label: "门店名称POS",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "chStoreCodeKingdee",
                  label: "门店编码金蝶",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "chJobTitileName",
                  label: "职位名称",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "chO2oStoreCodePos", label: "云端门店编码POS" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "chInsertTime",
                  label: "插入时间",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatDate(scope.row.chInsertTime)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "120",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.searchForm.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.searchForm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑数据",
            visible: _vm.dialogVisible,
            width: "800px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "人员编码", prop: "chPersonCode" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: "请输入人员编码" },
                    model: {
                      value: _vm.form.chPersonCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chPersonCode", $$v)
                      },
                      expression: "form.chPersonCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "人员名称", prop: "chPersonName" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: "请输入人员名称" },
                    model: {
                      value: _vm.form.chPersonName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chPersonName", $$v)
                      },
                      expression: "form.chPersonName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "chMobile" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: "请输入手机号" },
                    model: {
                      value: _vm.form.chMobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chMobile", $$v)
                      },
                      expression: "form.chMobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "出品部门", prop: "chProductTypeDept" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: "请输入出品部门" },
                    model: {
                      value: _vm.form.chProductTypeDept,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chProductTypeDept", $$v)
                      },
                      expression: "form.chProductTypeDept",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "角色", prop: "chRoleName" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择角色", disabled: "" },
                      model: {
                        value: _vm.form.chRoleName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "chRoleName", $$v)
                        },
                        expression: "form.chRoleName",
                      },
                    },
                    _vm._l(_vm.ruleList, function (item) {
                      return _c("el-option", {
                        key: item.roleName,
                        attrs: { label: item.roleName, value: item.roleName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "员工角色", prop: "roleIds" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        placeholder: "请选择员工角色",
                        clearable: "",
                      },
                      on: { change: _vm.handleRoleChange },
                      model: {
                        value: _vm.form.roleIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "roleIds", $$v)
                        },
                        expression: "form.roleIds",
                      },
                    },
                    _vm._l(_vm.roleList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店编码POS", prop: "chStoreCodePos" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: "请输入门店编码POS" },
                    model: {
                      value: _vm.form.chStoreCodePos,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chStoreCodePos", $$v)
                      },
                      expression: "form.chStoreCodePos",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店名称POS", prop: "chStoreNamePos" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: "请输入门店名称POS" },
                    model: {
                      value: _vm.form.chStoreNamePos,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chStoreNamePos", $$v)
                      },
                      expression: "form.chStoreNamePos",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "门店编码金蝶", prop: "chStoreCodeKingdee" },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: "请输入门店编码金蝶" },
                    model: {
                      value: _vm.form.chStoreCodeKingdee,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chStoreCodeKingdee", $$v)
                      },
                      expression: "form.chStoreCodeKingdee",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "职位名称", prop: "chJobTitileName" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: "请输入职位名称" },
                    model: {
                      value: _vm.form.chJobTitileName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chJobTitileName", $$v)
                      },
                      expression: "form.chJobTitileName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "云端门店编码POS",
                    prop: "chO2oStoreCodePos",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: "",
                      placeholder: "请输入云端门店编码POS",
                    },
                    model: {
                      value: _vm.form.chO2oStoreCodePos,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "chO2oStoreCodePos", $$v)
                      },
                      expression: "form.chO2oStoreCodePos",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }